const grid: LAYOUT.IGrid = {
		styles: {
			style: {
				width: '100vw',
				minHeight: '100vh',
				gridTemplateRows: '72px repeat(6, min-content) 1fr',
				gridTemplateColumns: 'min-content minmax(860px, 1fr)',
				gridTemplateAreas:
					"'aside header'" +
					"'aside alerts'" +
					"'aside helpcenter'" +
					"'aside breadcrumbs'" +
					"'aside title'" +
					"'aside wizard'" +
					"'aside viewport'" +
					"'aside panel'"
			}
		}
	},
	panel: LAYOUT.IGridItem = {
		name: 'panel',
		component: 'TheNavPanel',
		styles: {
			style: {
				paddingBottom: '24px'
			}
		}
	},
	wizard: LAYOUT.IGridItem = {
		name: 'wizard',
		component: 'TheWizardSteps'
	},
	alerts: LAYOUT.IGridItem = {
		name: 'alerts',
		component: 'TheAlertNode'
	},
	helpcenter: LAYOUT.IGridItem = {
		name: 'helpcenter',
		component: 'HelpCenterNode'
	},
	breadcrumbs: LAYOUT.IGridItem = {
		name: 'breadcrumbs',
		component: 'TheBreadcrumbs'
	},
	title: LAYOUT.IGridItem = {
		name: 'title',
		component: 'TheContentTitle'
	},
	aside: LAYOUT.IGridItem = {
		name: 'aside',
		component: 'TheSideBar',
		styles: {
			style: {
				top: '0',
				zIndex: '2001',
				position: 'sticky',
				height: '100vh'
			}
		}
	},
	header: LAYOUT.IGridItem = {
		name: 'header',
		component: 'TheNavBar',
		styles: {
			style: {
				top: '0',
				zIndex: '2000',
				position: 'sticky'
			}
		}
	},
	banner: LAYOUT.IGridItem = {
		name: 'banner',
		component: 'TheBanner',
		styles: {
			style: {
				top: '0',
				zIndex: '2000',
				position: 'sticky'
			}
		}
	};

export function createVueTemplate(serverProps: APS.IServerProps): LAYOUT.ILayoutTemplate {
	const style = (grid.styles as LAYOUT.IGridItemStyles).style as Partial<CSSStyleDeclaration>;
	const { impersonatedWarning } = serverProps.breadcrumbs || {};

	const items = [alerts, wizard, helpcenter, breadcrumbs, title, header, aside, panel];

	if (impersonatedWarning) {
		style.gridTemplateAreas = "'banner banner'" + style.gridTemplateAreas;
		style.gridTemplateRows = '40px ' + style.gridTemplateRows;

		((aside.styles as LAYOUT.IGridItemStyles).style as Partial<CSSStyleDeclaration>).height = 'calc(100vh - 40px)';
		((aside.styles as LAYOUT.IGridItemStyles).style as Partial<CSSStyleDeclaration>).top = '40px';
		((header.styles as LAYOUT.IGridItemStyles).style as Partial<CSSStyleDeclaration>).top = '40px';

		items.push(banner);
	}

	return {
		grid,
		items
	};
}
